// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { dateSchema } from "../commonSchemas";

export const path = "edit-load";

export const updateLoadParamsSchema = z.object({
  loadId: z.string(),
  sourceStation: z.string().nullable(),
  destinationStation: z.string().nullable(),
  weight: z.number().nullable(),
  pieces: z.number().nullable(),
  notes: z.string().nullable(),
  pickupStart: dateSchema.nullable(),
  pickupEnd: dateSchema.nullable(),
  deliveryStart: dateSchema.nullable(),
  deliveryEnd: dateSchema.nullable(),
});




export type UpdateLoadParams = z.infer<typeof updateLoadParamsSchema>;




// vendor/edit-load endpoint
export function updateLoad(
  params: z.input<typeof updateLoadParamsSchema>
): Promise<void> {
  return requestHandler(
    "vendor/edit-load",
    params,
    undefined,
  );
}

